import React from 'react'

interface DemoVideoRequestPromptProps {
  userName: string
}

const DemoVideoRequestPrompt: React.FC<DemoVideoRequestPromptProps> = ({ userName }) => {
  const email = 'support@candihealth.com'
  const subject = 'Requesting Demo Video'
  const body = `Hi Support Team,%0A%0AThis is ${userName} requesting a demo video for .... %0A%0AThanks!`
  const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${body}`

  return (
    <div className="alert alert-light rounded-3 shadow-sm d-flex justify-content-start align-items-center py-3 mb-4">
      <span className="text-secondary fw-normal">
        Can’t find a guide you’re looking for?{' '}
        <a
          href={mailtoLink}
          className="fw-semibold text-primary text-decoration-none"
          target="_blank"
          rel="noopener noreferrer"
        >
          Request now
        </a>
      </span>
    </div>
  )
}

export default DemoVideoRequestPrompt
